import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function NotFoundPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <p className="text-5xl font-bold text-slate-300">404</p>
      <p className="mt-3 text-sm text-slate-600">{t('errors.pageNotFound')}</p>
      <Link
        to="/"
        className="mt-5 inline-flex h-10 items-center rounded-lg bg-brand-600 px-4 text-sm font-medium text-white hover:bg-brand-700"
      >
        {t('errors.goHome')}
      </Link>
    </div>
  );
}
